import React, { useEffect, useState } from 'react'

// Components
import Document from 'components/Document'
import DocumentationLayout from 'components/DocumentationLayout'
import MainContentArea from 'components/MainContentArea'

// API
import { content as retrieveContent } from 'api/docset'

//Types
import {Content} from 'types/docset'

// Util
import { HELP_DOCSET_ALIAS, HELP_DOCSET_CFR, HELP_DOCSET_PAGE_NOT_FOUND } from 'util/constants'

interface Props {
  language: string
}

const NotFound = ({language}:Props) => {
  const [content, setContent] = useState<Content>()

  useEffect(() => {
    retrieveContent(HELP_DOCSET_ALIAS, HELP_DOCSET_CFR, HELP_DOCSET_PAGE_NOT_FOUND)
      .then(setContent)
  }, [language])

  const contentEl = content && 
    <MainContentArea
      minimal
      content={<Document alias={HELP_DOCSET_ALIAS} cfr={HELP_DOCSET_CFR} page={HELP_DOCSET_PAGE_NOT_FOUND} content={content} help={true} lang={undefined} isViya4={false}/>}
    />

  return (
    <>
      <DocumentationLayout 
        sidebarVisible={false}
        toggleSidebar={()=>{}}
        minimal
        content={contentEl}
      />
    </>
  )
}

export default NotFound